module.exports = __webpack_public_path__ + "img/EXEMPLO_DE_COPYRIGHT_PLATAFORMA.8eaed67b.jpg";